import { msg } from '@lingui/core/macro'

export const SKIP_REASONS = [
  { code: 'TOPIC_UNCLEAR', label: msg`I don't understand the topic` },
  { code: 'TOPIC_UNCOMFORTABLE', label: msg`I'm not comfortable with this topic` },
  { code: 'TOPIC_NO_KNOWLEDGE', label: msg`I don't know enough about this topic` }
] as const

export type SkipReasonCode = (typeof SKIP_REASONS)[number]['code']
